import React, { Component } from 'react';

import {API_BASE_URL} from '../../constants'

import axios from 'axios'
import {getToken} from '../../storage'
import {NotificationManager} from 'react-notifications'

class AddGst extends Component {


  constructor(props) {
    super(props)
    this.addgst = this.addgst.bind(this)

    this.handleInputChange = this.handleInputChange.bind(this)

    this.modifyItemState = this.modifyItemState.bind(this)
    this.getGst = this.getGst.bind(this)
    this.deleteGst = this.deleteGst.bind(this)
    this.state = {gst: {cgst:0, sgst:0, igst:0}}
  }

  componentDidMount() {
    if(typeof this.props.match !=="undefined" && typeof this.props.match.params.gst_id !== "undefined") {
      this.setState({mode:'edit'})
      document.title = "Edit Gst " + this.props.match.params.gst_id
      this.getGst(this.props.match.params.gst_id).then((response)=>{
        if(response.status===200) {
          this.setState({gst: response.data.gst, loading:false})

        }
      }).catch((err)=>{
        this.setState({loading:false})
      })
    }

    else {
        document.title = "Create Gst"
        this.setState({loading:false})
    }

  }

  getGst(gst_id) {
    return axios({
      url: '/get_gst/?id='+gst_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  modifyItemState(name, value) {
    let gst = this.state.gst
    gst[name] = value
    this.setState({gst:gst})
  }


  handleInputChange(e) {
    var name = e.target.name

    if (name === "cgst" || name=== "sgst") {
        this.modifyItemState('cgst', e.target.value)
        this.modifyItemState('sgst', e.target.value)
        this.modifyItemState('igst', e.target.value * 2)
    }
    else {
        this.modifyItemState('igst', e.target.value)
        this.modifyItemState('cgst', e.target.value/2)
        this.modifyItemState('sgst', e.target.value/2)
    }

  }
  deleteGst() {

    axios({
      url: '/delete_gst/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.gst
    }).then((response)=> {
      if(response.status === 200) {
          NotificationManager.success("Deleted Gst successfully")
        setTimeout(()=>{
          this.props.history.push("/gsts/")
        }, 700)
      }
    }).catch((err)=> {
      console.log(err);
    })
  }
  addgst(e) {
    this.setState({error_response_data: undefined})
    e.preventDefault()

    let apiurl
    if(this.state.mode ==="edit") {
      apiurl  = "/update_gst/"
    }
    else {
      apiurl  = "/create_new_gst/"
    }




    axios({
      baseURL: API_BASE_URL,
      url:apiurl,
      method:"POST",
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data:this.state.gst
    }).then((response)=>{

      this.setState({gst:response.data.gst, submitting:false})
      if(typeof this.props.onAddCallback !== "undefined") {
      this.props.onAddCallback(response.data.gst)
      }
      else {

        if(this.state.mode==="edit") {
          NotificationManager.success("Updated Gst successfully")
        }
        else {
          NotificationManager.success("Created Gst successfully")
        }

        setTimeout(()=>{

          this.props.history.push("/gsts/")
        }, 700)
      }


    }).catch(err=>{

      if(typeof err.response !== "undefined" && typeof err.response.data !== "undefined") {
        this.setState({error_response_data:err.response.data})
      }

    })
  }


  render() {

    let error_response_data = this.state.error_response_data
    let errors
    let cgst_error, sgst_error, igst_error
    if(typeof error_response_data !== "undefined") {
      errors = error_response_data.errors
      console.log(errors);
      if(typeof errors.cgst_error !== "undefined" && errors.cgst_error.length > 0) {
        cgst_error = errors.cgst_error[0]
      }
      if(typeof errors.sgst_error !=="undefined" && errors.sgst_error.length>0) {
        sgst_error = errors.sgst_error[0]
      }
      if(typeof errors.igst_error !=="undefined" && errors.igst_error.length>0) {
        igst_error = errors.igst_error[0]
      }

    }


    let gst = this.state.gst



    let pageHeader, deleteGstBtn
    if(this.state.mode === "edit") {
      deleteGstBtn = <button className="btn btn-danger" onClick={this.deleteGst}>Delete Gst</button>
      pageHeader = <h3>{"Edit Gst  " + gst.primary_gst}</h3>
    }
    else {
      pageHeader =  <h3 >Create New Gst</h3>
    }

    return (
      <div>
      <section className="medium">
            {pageHeader}
            <ul className="list-inline">

              <li className="pull-right">{deleteGstBtn}</li>
            </ul>
      </section>
          <div className="">
              <div className="row">
                <div className="col-sm-12">

                    <div className="form-group">
                      <label htmlFor="cgst">CGST</label>
                        <input type="text" name="cgst" className="form-control"
                           onChange={this.handleInputChange} value={gst.cgst} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="sgst">SGST</label>
                      <input type="text" name="sgst" className="form-control"
                        onChange={this.handleInputChange} value={gst.sgst} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="igst">IGST</label>
                      <input type="text" name="igst" className="form-control"
                        onChange={this.handleInputChange} value={gst.igst} />
                    </div>
                    <span className="text-danger">{cgst_error}{sgst_error}{igst_error}</span>
                    <div className="form-group">
                      <input type="submit" className="btn btn-info btn-block" value="Submit" onClick={this.addgst}/>
                    </div>

                </div>
              </div>
          </div>


      </div>
    )
  }
}

export default AddGst



// WEBPACK FOOTER //
// ./src/components/gst/addgst.js